export const GET_DRIVE_TIME = "GET_DRIVE_TIME";
export const SCHEDULING_FILTERS = "SCHEDULING_FILTERS";
export const GET_SCHEDULE_BY_DAY = "GET_SCHEDULE_BY_DAY";
export const GET_SCHEDULE_BY_WEEK = "GET_SCHEDULE_BY_WEEK";
export const GET_WEATHER_BY_WEEK = "GET_WEATHER_BY_WEEK";
export const GET_SCHEDULING_FORM_DATA = "GET_SCHEDULING_FORM_DATA";
